export default "__VITE_ASSET__BYUtj5nf__"